// /**
//  * Four Column Carousel
//  */

import 'owl.carousel/dist/owl.carousel.min.js';

import $ from 'jquery';

const fourColCarousel = {
  prevIcon: '<span class="carousel-control-prev-icon" aria-hidden="true"></span>',
  nextIcon: '<span class="carousel-control-next-icon" aria-hidden="true"></span>',
  initFourColCarousel: () => {
    // Make whole card clickable
    const carousel = $('.four-col-carousel');
    const cards = carousel.find('.four-col-card');
    cards.each(function () {
      const $this = $(this);

      $this.on('click', function (e) {
        if ($this.find($(e.target).closest('a')[0]).length === 0) {
          // Not on the anchor, do it
          e.preventDefault();
          $this.find('a')[0].click();
        }
      });
    });

    // Add Resize listener to enable/disable carousel
    $(window).on('resize', function () {
      if (
        $(window).width() < 961 &&
        $('.four-col-carousel-wrapper').find('>:first-child').hasClass('off')
      ) {
        fourColCarousel.startCarousel();
        $('.four-col-carousel-wrapper').find('>:first-child').removeClass('off');
        $('.four-col-carousel-wrapper').find('>:first-child').addClass('on');
      } else if (
        $(window).width() >= 961 &&
        $('.four-col-carousel-wrapper').find('>:first-child').hasClass('on')
      ) {
        if ($('.four-col-carousel-wrapper').find('>:first-child').hasClass('on')) {
          $('.four-col-carousel-wrapper').each(function () {
            // Disable/destroy owl-carousel and updated classes
            $(this).find('>:first-child').trigger('destroy.owl.carousel');
            $(this).find('>:first-child').removeClass('on');
            $(this).find('>:first-child').addClass('off');

            // Re-add icon elements lost in destruction of owl-carousel
            if (
              $(this).find('.carousel-control-prev-icon').length === 0 &&
              $(this).find('.carousel-control-next-icon').length === 0
            ) {
              $(this).find('.carousel-control-prev').prepend(fourColCarousel.prevIcon);
              $(this).find('.carousel-control-next').prepend(fourColCarousel.nextIcon);
            }
          });
        }
      }
    });

    // If screen is md or small start owl-carousel
    $('.four-col-carousel-wrapper').each(function () {
      if ($(window).width() < 961) {
        fourColCarousel.startCarousel();
        $(this).find('>:first-child').addClass('on');
        $(this).find('>:first-child').removeClass('off');
      } else {
        $('.four-col-carousel-wrapper').each(function () {
          $(this).find('>:first-child').trigger('destroy.owl.carousel');
          $(this).find('>:first-child').removeClass('on');
          $(this).find('>:first-child').addClass('off');
        });
      }
    });
  },
  startCarousel: () => {
    $('.four-col-carousel-wrapper').each(function () {
      $(this)
        .find('>:first-child')
        .owlCarousel({
          smartSpeed: 300,
          direction: 'next',
          slideTransition: 'linear',
          loop: false,
          slideBy: 1,
          margin: 12,
          stagePadding: 0,
          nav: true,
          dots: true,
          autoWidth: true,
          lazyload: false,
          navText: [
            $(this).find('.carousel-control-prev-icon'),
            $(this).find('.carousel-control-next-icon'),
          ],
          responsive: {
            0: {
              slideBy: 1,
              dots: true,
              dotsEach: 1,
            },
            500: {
              slideBy: 1,
              dots: true,
              dotsEach: 1,
            },
            575: {
              slideBy: 1,
              dots: true,
              dotsEach: 1,
            },
            600: {
              slideBy: 1,
              dots: true,
              dotsEach: 1,
            },
            990: {
              slideBy: 1,
              dots: false,
            },
            1200: {
              slideBy: 1,
              dots: false,
            },
            1400: {
              slideBy: 1,
              dots: false,
            },
            1600: {
              slideBy: 1,
              dots: false,
            },
          },
          onInitialized() {
            $('.four-col-carousel').find('.owl-item').attr('aria-current', 'false');
            $('.four-col-carousel').find('.owl-item.active').attr('aria-current', 'true');
            // Add aria attribute to dots
            $('.four-col-carousel')
              .find('.owl-dot')
              .each(function (index) {
                //Add one to index so it starts from 1
                $(this).attr('aria-label', `slide ${index + 1}`);
              });
            $('.four-col-carousel').attr('tabindex', '0');
            // Add aria attributes to buttons
            $('.four-col-carousel').find('.owl-prev').attr('aria-label', 'previous');
            $('.four-col-carousel').find('.owl-prev').attr('role', 'button');
            $('.four-col-carousel').find('.owl-next').attr('aria-label', 'next');
            $('.four-col-carousel').find('.owl-next').attr('role', 'button');

            // Remove controls
            const nav = $('.four-col-carousel').find('.owl-nav');
            const dots = $('.four-col-carousel').find('.owl-dots');
            const items = $('.four-col-carousel').find('.owl-item');

            if (items.length <= 1) {
              nav.addClass('hide-small');
              dots.addClass('hide-small');
            } else if (items.length <= 3) {
              nav.addClass('hide-large');
              dots.addClass('hide-large');
            }

            // Make entire tile clickable
            items.on('click', (e) => {
              window.location = e.currentTarget.querySelector('a').href;
            });
          },
        });
    });
  },
};

export default fourColCarousel;
